import { render, staticRenderFns } from "./TRXConFactor.vue?vue&type=template&id=27e01269&scoped=true&"
import script from "./TRXConFactor.vue?vue&type=script&lang=js&"
export * from "./TRXConFactor.vue?vue&type=script&lang=js&"
import style0 from "./TRXConFactor.vue?vue&type=style&index=0&id=27e01269&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e01269",
  null
  
)

export default component.exports